import React from "react";

import { BrowserRouter, BrowserRouter as Router } from "react-router-dom";
import AppRouter from "../components/AppRouter";

const MainRouter = (props) => {
  return <AppRouter />;
};
export default MainRouter;
